import { dataPlus } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlus = /*#__PURE__*/createIcon(dataPlus)
export default IconPlus
